import { render, staticRenderFns } from "./FormSelectPagination.vue?vue&type=template&id=3ff088ea"
import script from "./FormSelectPagination.vue?vue&type=script&lang=js"
export * from "./FormSelectPagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/al-khaleej/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ff088ea')) {
      api.createRecord('3ff088ea', component.options)
    } else {
      api.reload('3ff088ea', component.options)
    }
    module.hot.accept("./FormSelectPagination.vue?vue&type=template&id=3ff088ea", function () {
      api.rerender('3ff088ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/form/FormSelectPagination.vue"
export default component.exports